module.exports = __webpack_public_path__ + "img/logo-no-text.6d8fc494.svg";